import React, { Component } from "react";
import GolfStatusTable from "./GolfStatusTable";
import GolfMessageTable from "./GolfMessageTable";

class GolfStatusPage extends Component {
  render() {
    return (
      <div>
        <div>
          <h3>Status</h3>
          <GolfStatusTable />
        </div>
        <div>
          <h3>Messages for today</h3>
          <GolfMessageTable />
        </div>
      </div>
    );
  }
}

export default GolfStatusPage;
